// Dependency
import { Link } from "gatsby";
import React, { useState } from "react";
import ArrowLeftIcon from "../../../images/arrowLeft";
import { Sheet, SheetTrigger, SheetContent, SheetClose } from "../../sheet";
import * as mobileMenuStyles from './mobilemenu.module.scss';
import UtilsService from "../../../services/utils.service";

const MenuTree = (props) => {

    const localeMap = UtilsService.localeMap;

    let title = props.content._allTitleLocales.filter((mobileMenuLocale) => {
        return mobileMenuLocale.locale === localeMap[props.country];
    });

    const [openMenuTree, setOpenMenuTree] = useState(false)

    function handleCloseSheets() {
        setOpenMenuTree(false)
        props.closeParentSheet(false)
      }

return (
    <Sheet open={openMenuTree} onOpenChange={handleCloseSheets}>
        <div 
            className="cd-mobile-tree-item"
            onClick={() => setOpenMenuTree(true)}
        >
            {
                title && title.length > 0 ? title[0].value : props.content.title
            }
            <span className={`${mobileMenuStyles.cdArrow} cd-arrow`}></span>
        </div>
        <SheetContent hideOverlay={true} side={'left'} className="cd-moible-sheet">
            <div className={`${mobileMenuStyles.cdMobileMenuHeader} cd-dark-mode-border`}>
                <SheetClose >
                    <ArrowLeftIcon />
                </SheetClose>
                <div className={mobileMenuStyles.cdMobileMenuHeaderItem}>
                    <SheetClose className={`${mobileMenuStyles.cdMobileMenuClose}`}>
                        <i className="material-icons">close</i>
                    </SheetClose>
                </div>
            </div>
                
            <div className={mobileMenuStyles.cdMobileMenuContent}>
                <div className={mobileMenuStyles.cdMobileMenuLinks}>
                    <SheetClose asChild >
                        <Link  className="cd-dark-mode-border" to={`/${props.country}/${props.content.link.slug}/`}>
                            Shop all
                        </Link>
                    </SheetClose>
                    {
                        props.content.tree.map((menuLink, index) => {
                            let link = menuLink._allUrlLocales.filter((mobileMenuLocale) => {
                                return mobileMenuLocale.locale === localeMap[props.country];
                            });
                            let name = menuLink._allNameLocales.filter((mobileMenuLocale) => {
                                return mobileMenuLocale.locale === localeMap[props.country];
                            });

                            return (
                                <SheetClose
                                    key={index}
                                    asChild
                                >
                                    <Link  className="cd-dark-mode-border" to={`/${props.country}${link[0].value}`}>
                                        {name[0].value}
                                    </Link>
                                </SheetClose>
                            )
                        }
                    )
                    }
                </div>
            </div>
        </SheetContent>
    </Sheet>
    );
    
}

export default MenuTree